import { useContext } from 'react'
import { VodItemsContext } from './VodItemsContext'

export const useVodItemsContext = () => {
    const context = useContext(VodItemsContext)
    if (context === undefined) {
        throw new Error(
            'useVodItemsContext must be used within a VodItemsProvider'
        )
    }
    return context
}
